/**
 * FAQ block — front-end interactivity (viewScript, loaded only on pages that
 * use this block).
 *
 * Classic accordion: clicking a question opens its answer and closes any
 * other open item in the SAME `[data-qr-part="faq-list"]` — scoped per list
 * so multiple FAQ blocks on one page don't affect each other. The actual
 * height animation is pure CSS (grid-template-rows, see faq-item/style.css);
 * this script only toggles the `is-open` class and aria-expanded.
 */

function initFaqLists() {
	document.querySelectorAll('[data-qr-part="faq-list"]').forEach((list) => {
		const items = list.querySelectorAll(':scope > [data-qr-part="item"]');

		items.forEach((item) => {
			const trigger = item.querySelector(':scope > [data-qr-part="trigger"]');
			if (!trigger) return;

			trigger.addEventListener('click', () => {
				const isOpen = item.classList.contains('is-open');

				items.forEach((other) => {
					other.classList.remove('is-open');
					const otherTrigger = other.querySelector(':scope > [data-qr-part="trigger"]');
					if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
				});

				if (!isOpen) {
					item.classList.add('is-open');
					trigger.setAttribute('aria-expanded', 'true');
				}
			});
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initFaqLists);
} else {
	initFaqLists();
}
